<template>
  <v-container fluid>
    <v-list-item two-line v-if="message.data">
      <v-list-item-icon>
        <v-icon>mdi-database</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="title mb-1"
          >Elaborator Data</v-list-item-title
        >
        <v-list-item-subtitle
          >The data as compiled by the elaborator prompts and answers from the
          member</v-list-item-subtitle
        >
      </v-list-item-content>
    </v-list-item>

    <v-list class="mt-4" v-if="Object.keys(message.data).length">
      <v-list-item
        class="mt-n6"
        two-line
        v-for="(value, key) in message.data"
        :key="key"
      >
        <v-list-item-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1 grey--text">{{
            key | title_case
          }}</v-list-item-title>
          <p v-if="photoProps.includes(key)" class="body-2 grey--text"><em>View photos in message tab</em></p>
          <p class="body-2" v-else-if="typeof value !== 'object' && value !== null">
            {{ typeof value === "boolean" ? (value ? "Yes" : "No") : value }}
          </p>
          <p class="body-2" v-else-if="typeof value === 'object' && value !== null">
            <span class="d-block" v-for="(value, key) in value" :key="key">
              <span class="font-weight-bold">{{ key | title_case }}:</span>
              {{ typeof value === "boolean" ? (value ? "Yes" : "No") : value }}
            </span>
          </p>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list-item two-line v-if="message.data && !readOnly">
      <v-list-item-icon>
        <v-icon>mdi-code-braces</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <tree-view
          class="py-2 data-tree"
          :data="message.data"
          :options="{ rootObjectKey: 'data', maxDepth: 0, modifiable: true }"
          @change-data="onChangeData"
        ></tree-view>
      </v-list-item-content>
    </v-list-item>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({}),
  created() {},
  mounted() {},
  computed: {
    photoProps() {
      let props = [];

      if (this.message.data) {
        for (const key in this.message.data) {
          if (Object.hasOwnProperty.call(this.message.data, key)) {
            const value = this.message.data[key];
            if (Array.isArray(value)) {
              let photoData = value.filter(data => data.telegram_file);
              if (photoData && photoData.length) {
                props.push(key);
              }
            }
          }
        }
      }

      return props;
    }
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    async onChangeData(data) {
      try {
        this.message.data = data;
        await this.message.save();
        this.showMessage({
          text: "Saved changes to data!",
          color: "success",
        });
      } catch (error) {
        this.showMessage({
          text: "Could not save changes to data!",
          color: "error",
        });
      }
    },
  },
  watch: {},
  props: {
    message: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.data-tree {
  .tree-view-item-leaf {
    .tree-view-item-key-with-chevron::before {
      color: #666;
    }

    input {
      color: #999;
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #9e9e9e;
      border-radius: 0;
      outline: none;
      height: 2rem;
      width: auto;
      font-size: 110%;
      margin: 0 0 8px 0;
      padding: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      -webkit-transition: border 0.3s, -webkit-box-shadow 0.3s;
      transition: border 0.3s, -webkit-box-shadow 0.3s;
      transition: box-shadow 0.3s, border 0.3s;
      transition: box-shadow 0.3s, border 0.3s, -webkit-box-shadow 0.3s;
    }
  }
}
</style>